import React from 'react';
import { renderToString } from 'react-dom/server';
import { Helmet } from 'react-helmet';
import striptags from 'striptags';

import type { FaqType } from '..';

type FaqSchemaProps = {
  faqs: FaqType[];
};

export const FaqSchema = ({ faqs }: FaqSchemaProps) => {
  const convertToString = (answer: React.ReactNode) => {
    let answerString = '';
    if (React.isValidElement(answer)) {
      answerString = renderToString(answer);
    }
    if (typeof answer === 'string') {
      answerString = answer;
    }

    return striptags(answerString);
  };

  const schemaQuestionAnswerList = faqs.map((faq) => {
    return {
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: convertToString(faq.answer),
      },
    };
  });

  const schemaObject = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: schemaQuestionAnswerList,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaObject)}</script>
    </Helmet>
  );
};
